<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back" v-bind:class="{'hidden': chamada}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">Detalhes do pedido</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-80 bottom-sp60" style="background: #f7f7f7" v-if="detalhes">
            <div class="container hidden-xs hidden-md" style="padding-left: 0px; padding-right: 0px;">
                <h2>Detalhes do pedido</h2>
            </div>

            <div v-if="detalhes.catalogoMetodo == 'exame'" class="block block-strong inset mt-5" style="margin-bottom: 0px">
                <p style="line-height: 140%; color: red">
                    <i class="las la-exclamation-triangle"></i> <b>Aviso sobre exames</b>: {{detalhes.prestador.empresa ? detalhes.prestador.empresa : detalhes.prestador.nome}} deverá entrar em contato com você pelo telefone/WhatsApp para agendar o melhor dia e horário para a realização dos exames.
                </p>
            </div>                

            <div class="block mb-0 pb-0">
                <div class="row">

                    <button type="button" class="button mb-10 button-fill button-large color-secondary" v-on:click="alterarStatus(detalhes.cod, 'iniciar', false)" v-if="detalhes.catalogoMetodo != 'exame' && ($root.user.tipo == 'prestador' || $root.user.tipo == 'admin') && detalhes.status == 1 && !$root.chamada">
                        <i class="las la-play"></i>
                        Iniciar atendimento
                    </button>
                    
                    <button type="button" class="button mb-10 button-fill button-large color-secondary" v-on:click="alterarStatus(detalhes.cod, 'iniciar', false)" v-if="detalhes.agendaTipo == 'online' && ($root.user.tipo == 'prestador' || $root.user.tipo == 'admin') && (detalhes.status == 2 || detalhes.status == 3) && !$root.chamada">
                        <i class="las la-play"></i>
                        Abrir videoconferência
                    </button>                                                            

                    <button type="button" class="button mb-10 button-fill button-large color-secondary" v-on:click="alterarStatus(detalhes.cod, 'iniciar-contratante', false)" v-if="($root.user.tipo == 'contratante') && (detalhes.status == 2) && !$root.chamada">
                        <i class="las la-play"></i>
                        Iniciar atendimento
                    </button>   

                    <button type="button" class="button mb-10 button-fill button-large color-secondary" v-on:click="alterarStatus(detalhes.cod, 'iniciar-contratante', false)" v-if="detalhes.agendaTipo == 'online' && ($root.user.tipo == 'contratante') && (detalhes.status == 3) && !$root.chamada">
                        <i class="las la-play"></i>
                        Abrir videoconferência
                    </button>                                        
                    

                    <button type="button" class="button mb-10 button-fill button-large color-green" v-on:click="alterarStatus(detalhes.cod, 'concluir', false)" v-if="detalhes.status == 3">
                        <i class="las la-check-circle"></i>
                        Concluir atendimento
                    </button>

                    <button type="button" class="button mb-10 button-fill button-large color-green" v-on:click="alterarStatus(detalhes.cod, 'concluir', false)" v-if="detalhes.status == 1 && detalhes.catalogoMetodo == 'exame' && $root.user.tipo != 'contratante' ">
                        <i class="las la-check-circle"></i>
                        Definir como realizado
                    </button>                              
                </div>

                <div class="chamada-video" style="" v-if="!cordova && detalhes.status < 4 && detalhes.status > 1 && chamada">
                    <div class="content" style="width: 100%;">
                        <div id="remote-media" v-show="chamada"></div>
                        <div id="local-media" v-show="chamada"></div>
                    </div>

                    <button v-show="chamada" class="mute-audio" v-on:click="muteAudio()">
                        <i class="las la-microphone-slash" v-show="!mute.audio"></i>
                        <i class="las la-microphone" v-show="mute.audio"></i>
                    </button>
                    <button v-show="chamada" class="mute-video" v-on:click="muteVideo()">
                        <i class="las la-video-slash" v-show="!mute.video"></i>
                        <i class="las la-video" v-show="mute.video"></i>
                    </button>                                       
                </div>    

            </div>


            <div v-if="detalhes.pedido && !$root.user.empresaCod" class="card data-table data-table-init mt-0">
                <div class="card-header" style="min-height: 20px; padding-top: 7px; padding-bottom: 5px;">
                    <div class="data-table-title">Itens do pedido #{{detalhes.pedido.id}}</div>
                    <div class="data-table-actions">
                        
                    </div>
                </div>
                <div class="card-content">
<!--                     <div style="padding-left: 10px; padding-right: 10px">
                        <button type="button" class="mb-10 button-medium button button-fill color-red" v-on:click="cancelar(detalhes.cod)" v-if="detalhes.status == 1 || detalhes.status == 0">
                            <i class="las la-times"></i>
                            Cancelar pedido
                        </button>                               
                    </div> -->

                    <table>
                        <thead>
                            <tr>
                                <th class="label-cell">Serviço</th>
                                <th class="numeric-cell" style="text-align: right; width: 105px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in detalhes.pedido.itens" :key="item.cod">
                                <td class="label-cell" style="padding-top: 10px; padding-bottom: 10px; color: #333; line-height: 120%;">
                                    - {{item.nome}}

                                    <small v-if="item.data">
                                        <i class="las la-clock"></i> Agendado para:<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.dataExtenso}}
                                    </small>
                                </td>
                                <td class="numeric-cell" style="text-align: right; padding-left: 2px; padding-top: 10px; padding-bottom: 10px; color: #333; ">
                                    R$ {{item.valor | toMoney}}
                                </td>
                            </tr>
                            <tr v-if="detalhes.formaPagamento">
                                <td class="numeric-cell" data-collapsible-title="Valor total" style="text-align: right;">
                                    <span style="color: #666">                                 
                                        <i>Valor total</i>
                                    </span>
                                </td>                                
                                <td class="numeric-cell" data-collapsible-title="Valor total">
                                    <span style="color: #666; font-weight: bold;">                                 
                                        R$ {{detalhes.pedido.total  | toMoney}}
                                    </span>
                                </td>
                            </tr>    
                            <tr v-if="$root.user.tipo == 'prestador' && detalhes.formaPagamento">
                                <td class="numeric-cell" data-collapsible-title="Valor total" style="text-align: right;">
                                    <span style="color: #666">                                 
                                        <i>Valor que receberei</i>
                                    </span>
                                </td>                                
                                <td class="numeric-cell" data-collapsible-title="Valor total">
                                    <span style="color: #666; font-weight: bold;">                                 
                                        R$ {{detalhes.pedido.prestadorSplitValor  | toMoney}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                
                </div>
            </div>            

            <div class="card data-table data-table-collapsible data-table-init mt-0">
                <div class="card-header">
                    <div class="data-table-title">Detalhes do agendamento #{{detalhes.id}}</div>
                    <div class="data-table-actions">
                        <a class="link icon-only" v-on:click="get">
                            <i class="las la-sync-alt"></i>
                        </a>
                    </div>
                </div>
                <div class="card-content">

                    <div v-if="detalhes.status >= 1 && detalhes.status <= 3" class="block-title" style="margin-top: 10px; font-size: 14px">
                        <i class="las la-comment-dots"></i> 
                        Precisa entrar em contato?
                    </div>
                    <div v-if="detalhes.status >= 1 && detalhes.status <= 3" class="block ">
                        <div class="row mb-10">
                            <div class="col-50">
                                <button v-on:click="ligar(detalhes.contratante.telefone)" style="white-space: normal; height: auto; line-height: 120%; padding-top: 5px; padding-bottom: 5px;" class="button button-outline color-green" >
                                    <i class="las la-phone" style="font-size: 20px;"></i>
                                    Ligar p/ paciente
                                </button>                  
                            </div>                  
                            <div class="col-50">
                                <button v-on:click="whatsapp(detalhes.contratante.telefone)" style="white-space: normal; height: auto; line-height: 120%; padding-top: 5px; padding-bottom: 5px;" class="button button-outline color-green" >
                                    <i class="lab la-whatsapp" style="font-size: 20px;"></i>
                                    Chamar no WhatsApp
                                </button>                  
                            </div>                  
                        </div>                  
                    </div>

                    <table>
                        <tbody>
                            <tr>
                                <td class="numeric-cell" data-collapsible-title="Status">
                                    <span>
                                        <small v-if="detalhes.status == 0">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Pagamento pendente
                                            </span>
                                        </small>
                                        <small v-if="detalhes.status == 1 && detalhes.catalogoMetodo != 'exame'">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Agendado
                                            </span>
                                        </small>
                                        <small v-if="detalhes.status == 1 && detalhes.catalogoMetodo == 'exame'">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Aguardando realização
                                            </span>
                                        </small>    
                                        <small v-if="detalhes.status == 2">
                                            <span style="height: auto !important;" class="badge color-yellow">
                                                Aguardando paciente
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 3">
                                            <span style="height: auto !important;" class="badge color-blue">
                                                Atendimento em andamento
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 4">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Atendimento realizado
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 5">
                                            <span style="height: auto !important;" class="badge color-green">
                                                Atendimento realizado
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == -1">
                                            <span style="height: auto !important;" class="badge color-red">
                                                Cancelado
                                            </span>
                                        </small>                                         

                            <!--             // pedidos_status
                                        //    -3 : apagada
                                        //    -2 : reagendar
                                        //    -1 : cancelada
                                        //    0 : pendente
                                        //    1 : agendada
                                        //    2 : iniciada prestador
                                        //    3 : iniciada paciente
                                        //    4 : finalizada
                                        //    5 : avaliada
 -->                                        
                                    </span>
                                </td>
                                <td v-if="detalhes.status == -1" class="label-cell" data-collapsible-title="Motivo do cancelamento">
                                    <span style="color: red">
                                        {{detalhes.statusDescricao ? detalhes.statusDescricao : '-'}}
                                    </span>
                                </td>
                                <td class="label-cell" data-collapsible-title="Id">
                                    <span>
                                        #{{detalhes.id}}
                                    </span>
                                </td>
                                <td v-if="detalhes.data != '0000-00-00'" class="numeric-cell" data-collapsible-title="Agendado para">
                                    <span>
                                        {{detalhes.dataExtenso}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Serviço">
                                    <span>
                                        {{detalhes.descricao}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Tipo do atendimento">
                                    <span v-if="detalhes.agendaTipo == 'online'">
                                        Atendimento online
                                    </span>
                                    <span v-if="detalhes.agendaTipo == 'presencial'">
                                        Atendimento presencial
                                    </span>
                                    <span v-if="detalhes.agendaTipo == 'domiciliar'">
                                        Atendimento domiciliar
                                    </span>
                                </td> 
                                <td v-if="detalhes.formaPagamento" class="numeric-cell" data-collapsible-title="Forma de pagamento">
                                    <span>                                 
                                        {{detalhes.formaPagamentoNome}}
                                    </span>
                                </td>                                
                                <td class="numeric-cell" data-collapsible-title="Paciente">
                                    <span>
                                        {{detalhes.contratante.nome}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Profissional">
                                    <span>
                                        {{detalhes.prestador.empresa ? detalhes.prestador.empresa : detalhes.prestador.nome}}
                                    </span>
                                </td>      
                                <td class="numeric-cell" data-collapsible-title="Endereço do profissional" v-if="detalhes.agendaTipo == 'presencial'">
                                    <span>                                 
                                        {{detalhes.prestador.endereco}}, {{detalhes.prestador.numero != '' ? detalhes.prestador.numero : 's/n'}}. {{detalhes.prestador.cep}}. {{detalhes.prestador.bairro}}. {{detalhes.prestador.cidade}} - {{detalhes.prestador.estado}}

                                        <a :href="'https://www.google.com/maps?q=' + detalhes.prestador.endereco + ',' + detalhes.prestador.numero + ',' + detalhes.prestador.bairro + ',' + detalhes.prestador.cidade + ',' + detalhes.prestador.estado + ',Brasil'" target="_blank" class="link external" style="display: block; margin-bottom: 2px; font-weight: bold">
                                            <i class="las la-map-marker"></i>
                                            Abrir GPS
                                        </a>
                                    </span>
                                </td>                                                                      
                                <td class="numeric-cell" data-collapsible-title="Iniciado em" v-if="detalhes.iniciado != '0000-00-00 00:00:00'">
                                    <span>                                 
                                        {{detalhes.iniciado | formatDate}}h
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Finalizado em" v-if="detalhes.finalizado != '0000-00-00 00:00:00'">
                                    <span>                                 
                                        {{detalhes.finalizado | formatDate}}h
                                    </span>
                                </td>                                

                                <td v-if="detalhes.data != '0000-00-00'" class="numeric-cell" data-collapsible-title="Hora de início prevista">
                                    <span>                                 
                                        {{detalhes.horaInicio.substr(0, 5)}}h
                                    </span>
                                </td>
                                <td v-if="detalhes.data != '0000-00-00'" class="numeric-cell" data-collapsible-title="Hora final prevista">
                                    <span>                                 
                                        {{detalhes.horaFinal.substr(0, 5)}}h
                                    </span>
                                </td>      

                                <td class="numeric-cell" data-collapsible-title="Endereço do paciente" v-if="detalhes.agendaTipo == 'domiciliar'">
                                    <span>                                 
                                        {{detalhes.entregaEndereco}}, {{detalhes.entregaEnderecoNumero != '' ? detalhes.entregaEnderecoNumero : 's/n'}}. {{detalhes.entregaEnderecoCep}}. {{detalhes.entregaEnderecoBairro}}. {{detalhes.entregaEnderecoCidade}} - {{detalhes.entregaEnderecoEstado}}

                                        <a :href="'https://www.google.com/maps?q=' + detalhes.entregaEndereco + ',' + detalhes.entregaEnderecoNumero + ',' + detalhes.entregaEnderecoBairro + ',' + detalhes.entregaEnderecoCidade + ',' + detalhes.entregaEnderecoEstado + ',Brasil'" target="_blank" class="link external" style="display: block; margin-bottom: 2px; font-weight: bold">
                                            <i class="las la-map-marker"></i>
                                            Abrir GPS
                                        </a>
                                    </span>
                                </td>      

                                <td class="numeric-cell" data-collapsible-title="Avaliação" v-if="detalhes.avaliacaoContratante != 0">
                                    <div>
                                        <span style="display: block;"> 
                                            <b>Nota:</b> {{detalhes.avaliacaoContratanteNota}}   
                                        </span>
                                        <span v-if="detalhes.avaliacaoContratanteTexto" style="display: block;">
                                            <b>Comentário:</b> {{detalhes.avaliacaoContratanteTexto}}
                                        </span>                                    
                                    </div>                                
                                </td>                                                                                            

                                <td class="numeric-cell" data-collapsible-title="Última atualização">
                                    <span>                                 
                                        {{detalhes.datahora | formatDate}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Efetuado em">
                                    <span>                                 
                                        {{detalhes.datahora | formatDate}}
                                    </span>
                                </td>
                                <td v-if="detalhes.cupomNome" class="numeric-cell" data-collapsible-title="Cupom de desconto">
                                    <span>                                 
                                      {{detalhes.cupomNome}}
                                    </span>
                                </td>
                                <td v-if="detalhes.cupomNome" class="numeric-cell" data-collapsible-title="Desconto">
                                    <span>                                 
                                        R$ {{detalhes.desconto  | toMoney}}
                                    </span>
                                </td>                                                                

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'DetalhesPedidos',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "chamada":              null,
            "mute": {
                "audio": false,
                "video": false,
            },
            "realtime":             {},            
            "loading": {
                "submit":           false
            },  
            "detalhes":             null,
            "form": {
            }            
        }
    },
    watch: {
    },
    methods: {  
        ligar: function(telefone) {
            var self = this;
            console.log("ligar()", telefone);
            window.open("tel:" + telefone, "_blank");
        },      
        whatsapp: function(telefone) {
            var self = this;
            console.log("whatsapp()", telefone);
            window.open("https://api.whatsapp.com/send/?phone=55" + telefone + "&text=", "_blank");
        },              
        copiarChave: function() {
            var self = this;
            console.log("copiarChave()", self.pixChave);
            copyTextToClipboard(self.pixChave);
        },          
        // initChamada: function(token, room) {
        //     var self        = this;
        //     console.log("initChamada()", token, room);
        //     if (self.chamada) return false;

        //     self.chamada    = {
        //         "token":    token,
        //         "room":     room
        //     };

        //     self.$forceUpdate();

        //     window.__chamada = self.chamada;

        //     var Video = Twilio.Video;
        //     Video.createLocalVideoTrack().then(track => {
        //         var localMediaContainer = document.getElementById('local-media');
        //         window.__track = track;
        //         localMediaContainer.appendChild(track.attach());
        //     });

        //     Video.connect(token, {
        //         name:           room,
        //         bundlePolicy:   'max-compat'
        //     }).then(room => {
        //         console.log(`Successfully joined a Room: ${room}`);

        //         loading.hide();

        //         self.room   = room;
        //         window.__room = room;
        //         // _room       = room;

        //         var remoteMediaContainer = document.getElementById('remote-media');
        //             room.participants.forEach(function(participant) {
        //             console.log("Already in Room: '" + participant.identity + "'");
        //             participantConnected(participant, remoteMediaContainer);
        //         });

        //         room.on('participantConnected', participant => {
        //             console.log(`A remote Participant connected: ${participant}`);
        //             participantConnected(participant);
        //         });

        //         room.on('participantDisconnected', participant => {
        //             console.log(`A remote Participant connected: ${participant}`);
        //             participantDisconnected(participant);
        //         });

        //     }, error => {
        //         loading.hide();
        //         console.error(`Unable to connect to Room: ${error.message}`);
        //     });

        //     function participantConnected(participant) {
        //         console.log('Participant "%s" connected', participant.identity);
        //         const div   = document.createElement('div');
        //         div.id      = participant.sid;
        //         participant.on('trackSubscribed', (track) => {
        //             trackSubscribed(div, track)
        //         });
        //         participant.on('trackUnsubscribed', trackUnsubscribed);
        //         participant.tracks.forEach(publication => {
        //             if (publication.isSubscribed) {
        //                 trackSubscribed(div, publication.track);
        //             }
        //         });

        //         document.getElementById('remote-media').appendChild(div);
        //     }

        //     function participantDisconnected(participant) {
        //         console.log('Participant "%s" disconnected', participant.identity);

        //         var div     = document.getElementById(participant.sid)
        //         if (div) {
        //             div.remove();
        //         }
        //     }

        //     function trackSubscribed(div, track) {
        //         div.appendChild(track.attach());
        //     }

        //     function trackUnsubscribed(track) {
        //         track.detach().forEach(element => element.remove());
        //     }

        // },         
        // initRealTime: function() {
        //     var self                = this;
        //     Pusher.logToConsole     = true;

        //     self.realtime           = {};
        //     self.realtime.client    = new Pusher(self.$root.config.pusher.key, {
        //         cluster: 'mt1',
        //         activityTimeout: 2000,
        //         // enabledTransports: ['ws']                
        //     });
        //     self.realtime.channelPedido    = self.realtime.client.subscribe("pedidos-" + self.form.cod);
        //     self.realtime.channelPedido.bind("update", function(data) {
        //         console.log("atualizacao no pedido", data);

        //         if (window.__app.$route.name != "DetalhesPedidos") {
        //             console.log("Trocou de rota, entao finaliza pusher");
        //             self.realtime.client.disconnect();
        //             self.$forceUpdate();
        //         }

        //         self.setPedido(data.pedido);
                
        //     });    

        //     self.realtime.channel   = self.realtime.client.subscribe("chamada-" + self.form.cod + "-" + self.$root.user.cod);
        //     self.realtime.channel.bind("update", function(data) {
        //         console.log("atualizacao na chamada", data);
        //         if (data.tipo == "token") {
        //             self.initChamada(data.token, data.room);
        //         }
        //         if (data.tipo == "fim") {
        //         }
        //     });             
        // },
        // muteAudio: function() {
        //     var self = this;
        //     if (!self.mute.audio) {
        //         self.room.localParticipant.audioTracks.forEach((publication) => { 
        //             publication.track.disable(); 
        //         });
        //         self.mute.audio = true;
        //     } else {
        //         self.room.localParticipant.audioTracks.forEach((publication) => { 
        //             publication.track.enable(); 
        //         });                 
        //         self.mute.audio = false;
        //     }
        //     self.$forceUpdate();
        // },
        // muteVideo: function() {
        //     var self = this;
        //     if (!self.mute.video) {
        //         self.room.localParticipant.videoTracks.forEach((publication) => { 
        //             publication.track.disable(); 
        //         });
        //         self.mute.video = true;
        //     } else {
        //         self.room.localParticipant.videoTracks.forEach((publication) => { 
        //             publication.track.enable(); 
        //         });                 
        //         self.mute.video = false;
        //     }
        //     self.$forceUpdate();
        // },             
        setPedido: function(pedido) {
            console.log("setPedido()", pedido);
            var self = this;
            self.detalhes = JSON.parse(JSON.stringify(pedido));
            self.$forceUpdate();
        },              
        cancelar: function(cod) {
            
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod,
                    "status":       "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/pedidos-v2.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        alterarStatus: function(cod, status, message) {
            console.log("alterarStatus()", cod);
            
            var self                = this;
            

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "cod":          cod,
                "status":       status
            };                

            loading.show();
            
            axios.put("api/pedidos-v2.php", form)
            .then(response => {
                console.log("alterarStatus() response", response)
                loading.hide();
                self.get(true);
                if (message) alert(response.data.message);

            })
            .catch(error => {
                console.log("alterarStatus() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },      
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/pedidos-v2.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.loaded         = true;
                    // self.detalhes       = response.data.result;
                    self.setPedido(response.data.result);

                    // self.$root.getAvaliacoesPendentes();
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    activated: function() {
        var self = this;
        console.log("activated", self);

        self.cordova = window.cordova;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.cod = self.$route.query.c;

        if (self.$root.realtime.channelUsuario) {
            console.log("fez unbind pusher")
            self.$root.realtime.channelUsuario.unsubscribe("pedidos-usuario-" + self.$root.user.cod);
            self.$root.realtime.channelUsuario.unbind("update");
        }

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {

            self.$root.initRealtimeTeleconsulta(self.detalhes);
            self.$root.finalizarTeleconsulta = function() {
                console.log("finalizarTeleconsulta()")
                self.alterarStatus(self.detalhes.cod, 'concluir', false);
            }
            self.$root.setPedido = function(pedido) {
                console.log("setPedido() interno", pedido)
                self.setPedido(pedido);
                // self.alterarStatus(self.detalhes.cod, 'concluir', false);
            }            

            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });  


    },
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
   
    .page-detalhespedidos td span:not(.badge) {
        color: #222;
    }

    .page-detalhespedidos .badge {
        line-height: 100%;
        padding: 4px;        
    }

    .page-detalhespedidos .data-table.data-table-collapsible td { 
        border-bottom: 1px solid #efefef;
    }

    .link.back.hidden {
        opacity: 0 !important;
        pointer-events: none !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

    .block .button-large {
        font-weight: bold;
        font-size: 18px
    }

/* 
    #remote-media {
        width: 100%;
        text-align: center;
        height: 100%;
    }

    #remote-media video {
        max-width: 100% !important;
        width: auto !important;
        height: 80vh !important;        
        margin-top: 6px;
    }

    #local-media {
        display: flex;
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 100px;
        height: 100px;
        background: #000;
    }

    #local-media video {
        max-width: 100% !important;
    }


    .chamada-video {
        display: flex;
        align-items: center;
        background-color: #ddd; 
        height: 80vh;   
        position: relative;
    }

    .chamada-video .placeholder {
        width: 100%;
        opacity: 0.1;
    }

    .chamada-video p {
        text-align: center;
        color: #fff;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;    
        position: absolute;
    }


    .mute-audio {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-audio i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }

    .mute-video {
        position: absolute;
        bottom: 10px;
        left: 70px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-video i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }     */

    .data-table thead th {
        height: 24px;
    }

    .data-table table td small {
        color: red;
        font-weight: 600;
        margin-top: 5px;
/*        color: #000;*/
        display: block; 
        line-height: 130%;        
    }



</style>



// WEBPACK FOOTER //
// src/components/DetalhesPedidos.vue